import { IAuthContext } from 'src/state/providers/AuthProvider';
import { ResourceAttributes } from 'src/state/slice/models/CaseLifecycleTypes';
import {
  APP_CONTAINER_BASE_URL,
  UI_CLIENTS,
} from 'src/constants/GlobalConstants';
import { UmsUserAttribute } from '../types/UserContextTypes';
import {
  LocalStorageKeys,
  getLocalStorageItem,
} from 'src/utilities/LocalStorage';
import { getPreferredAccount } from 'src/utilities/AuthParamHelper';

export class ViciContext implements IAuthContext {
  emailId: string;
  customerId: string;
  customerFullName: string;
  accountAttributes: ResourceAttributes[];
  preferredAccountId: string;
  clientId: UI_CLIENTS;
  isAnonymousUser: boolean;
  setPreferredAccountId: Function;
  appContainerBaseUrl: APP_CONTAINER_BASE_URL;
  preselectedAccount = getLocalStorageItem(LocalStorageKeys.SELECTED_ACCOUNT);
  ddmIntakeFormSchemaId: string;

  constructor(
    umsUserAttribute: UmsUserAttribute,
    existingContext: IAuthContext,
  ) {
    this.accountAttributes = umsUserAttribute.accountAttributes;
    this.preferredAccountId = getPreferredAccount(
      this.preselectedAccount,
      this.accountAttributes,
    );

    this.emailId = `${umsUserAttribute.userId}@amazon.com`;
    this.customerId = umsUserAttribute.userId;
    this.customerFullName = umsUserAttribute.userId;
    this.clientId = UI_CLIENTS.VICI;
    this.isAnonymousUser = false;
    this.setPreferredAccountId = () => {};
    this.appContainerBaseUrl = existingContext.appContainerBaseUrl;
    this.ddmIntakeFormSchemaId = '';
  }

  getUserContext(): IAuthContext {
    return {
      emailId: this.emailId,
      customerId: this.customerId,
      customerFullName: this.customerFullName,
      accountAttributes: this.accountAttributes,
      preferredAccountId: this.preferredAccountId,
      clientId: this.clientId,
      setPreferredAccountId: this.setPreferredAccountId,
      isAnonymousUser: this.isAnonymousUser,
      appContainerBaseUrl: this.appContainerBaseUrl,
      ddmIntakeFormSchemaId: this.ddmIntakeFormSchemaId,
    };
  }
}
